<template>
  <GwInputNew
    :placeholder="placeholder || $t(`common.search`)"
    @update:value="handleSearchInput"
    @keyup.stop="$emit('keyup', $event)"
  />
</template>

<script>
import GwInputNew from '@/components/lib/GwInputNew.vue'
import Fuse from 'fuse.js'
import { throttle } from 'lodash'

function highlightFuseSearchResults({
  fuseSearchResult,
  highlightClassName = 'gw_highlight_text_letters',
}) {
  const set = (obj, path, value) => {
    const pathValue = path.split('.')
    let i

    for (i = 0; i < pathValue.length - 1; i++) {
      obj = obj[pathValue[i]]
    }

    obj[pathValue[i]] = value
  }
  const generateHighlightedText = (inputText, regions = []) => {
    let content = ''
    let nextUnhighlightedRegionStartingIndex = 0

    regions.forEach(region => {
      const lastRegionNextIndex = region[1] + 1

      content += [
        inputText.substring(nextUnhighlightedRegionStartingIndex, region[0]),
        `<span class="${highlightClassName}">`,
        inputText.substring(region[0], lastRegionNextIndex),
        '</span>',
      ].join('')

      nextUnhighlightedRegionStartingIndex = lastRegionNextIndex
    })

    content += inputText.substring(nextUnhighlightedRegionStartingIndex)

    return content
  }
  return fuseSearchResult
    .filter(({ matches }) => matches && matches.length)
    .map(({ item, matches, ...rest }) => {
      const highlightedItem = { ...item }

      matches.forEach(match => {
        set(highlightedItem, match.key, generateHighlightedText(match.value, match.indices))
      })

      return {
        item: highlightedItem,
        matches,
        ...rest,
      }
    })
}

export default {
  name: 'GwSearch',
  components: {
    GwInputNew,
  },
  props: {
    items: Array,
    setHighlight: Boolean,
    placeholder: String,
    fuseOptions: {
      default: () => ({
        shouldSort: true,
        includeScore: true,
        includeMatches: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['title'],
      }),
    },
  },
  emits: ['update:items', 'keyup'],
  data() {
    this.l_value = ''
    return {}
  },
  methods: {
    handleSearchInput: throttle(function (v) {
      this._handleSearchInput(v)
      this.l_value = v
    }, 111),
    _handleSearchInput(str = this.l_value) {
      const value = str.trim()
      if (!value) {
        this.$emit('update:items', this.items)
        return
      }

      const fuseSearchResult = new Fuse(this.items, this.fuseOptions) //
        .search(
          value, //
          this.fuseOptions,
        )

      let res = []
      if (this.setHighlight) {
        const searchedHighlighted = highlightFuseSearchResults({
          fuseSearchResult,
          highlightClassName: 'gw_highlight_text_letters',
        })
        res = searchedHighlighted.map(result => result.item)
      } else {
        res = fuseSearchResult.map(result => result.item)
      }
      // console.log({
      //   res, //
      //   searchedHighlighted,
      //   fuseSearchResult,
      // })
      this.$emit('update:items', res)
    },
  },
  watch: {
    items: {
      handler() {
        this._handleSearchInput()
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.gwsrch {
  --gwsearch-input-height: 2.16rem;
  --gwsearch-input-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &_input {
    padding: 0 2rem;
  }
  &_icon {
    position: absolute;
    left: 0.5rem;
    font-size: 1.25em;
  }
  &_clear {
    font-size: 1.25em;
    position: absolute;
    right: 0.25rem;
    cursor: pointer;
  }
}
</style>
